import React from 'react';
import { useState } from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import MedicalReportDetailWrapper from '../../../../Components/MedicalReport/MedicalReportDetailWrapper';
import apiClient from '../../../../Services/ApiClient';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import HealthPlanPrintPdfModal from '../HealthPlanPrintPdf/HealthPlanPrintPdfModal';
import useNotification from '../../../../Hooks/useNotification.hook';
import { useEffectAsync } from '../../../../helpers';
import Loading from '../../../../Components/Loading';

interface HealthPlanMedicalReportProps {
	patientId: string;
	workplaceId: string;
	loggedUserId?: string;
	caseId?: string;
	onSuccess: any;
	disableSubmit?: boolean;
}

export default function HealthPlanMedicalReport(
	props: HealthPlanMedicalReportProps,
) {
	const { onSuccess, patientId, workplaceId, caseId, disableSubmit } = props;
	const { translation } = useAppContext();
	const loggedUserId = props.loggedUserId
		? props.loggedUserId
		: useAppContext().loggedUserId;
	const { healthPlanUser, activeHealthPlanUserItem } = useHealthPlanContext();
	const [printModalOpen, setPrintModalOpen] = useState(false);
	const { showNotificationAlert } = useNotification();
	const [initialized, setInitialized] = useState<boolean>(false);
	const [defaultData, setDefaultData] = useState([]);

	// @ts-ignore
	useEffectAsync(async () => {
		let data = activeHealthPlanUserItem?.extra?.data;
		setDefaultData(data ?? null);
		setInitialized(true);
	});

	const handleSubmit = async (values: any) => {
		try {
			if (healthPlanUser && activeHealthPlanUserItem) {
				const result = await apiClient.patch(
					'/health-plan/' +
						healthPlanUser?.healthPlanId +
						'/user/' +
						healthPlanUser?.id +
						'/item/' +
						activeHealthPlanUserItem?.id,
					{
						extra: {
							data: values,
						},
					},
				);
				//TODO: Tady to nevraci documents co to vytvoří potřeba posílat z api v response aby se to pak dalo přidat do dekurz
				if (result) {
					setPrintModalOpen(true);
					const itemsForDiscourse = [
						{
							id: result?.data?.id,
							type: 'medicalReport',
						},
					];
					const discourseText =
						translation['discourse.healthPlan.diabetes.title'] +
						' - ' +
						translation['base.months.one'] +
						' ' +
						activeHealthPlanUserItem?.extra?.month +
						' - ' +
						translation['discourse.healthPlan.diabetes.medicalReportCreated'];
					//await writeActionToDiscourse(userData.workplaceId, patientId, userData.id, discourseText, itemsForDiscourse);
					return result;
				}
			}
		} catch (e: any) {
			if (e.response.data.displayableError) {
				showNotificationAlert({
					content: e.response.data.message,
				});
			}
		}
	};

	const handleAfterPrint = async () => {
		setPrintModalOpen(false);
		onSuccess && onSuccess();
	};

	if (!initialized) {
		return (
			<div className={'py-5'}>
				<Loading />
			</div>
		);
	}

	return (
		<>
			<MedicalReportDetailWrapper
				patientId={patientId}
				customSuccess={handleSubmit}
				workplaceId={workplaceId}
				defaultData={defaultData}
				loggedUserId={loggedUserId}
				caseId={caseId}
				disableSubmit={disableSubmit}
			/>
			<HealthPlanPrintPdfModal
				opened={printModalOpen}
				onClose={handleAfterPrint}
				healthPlanUser={healthPlanUser}
				healthPlanUserItem={activeHealthPlanUserItem}
			/>
		</>
	);
}
